module.exports = __webpack_public_path__ + "img/out-step1.6c687f0f.png";